import BaseCostUsageDataState from './baseCostUsageDataState';

export default class DynamicDataState extends BaseCostUsageDataState {
  constructor(context, dataState, nextDataState) {
    super(context);
    this.dataState = dataState;
    this.nextDataState = nextDataState;
  }

  getNewDataStateType() {
    return this.nextDataState;
  }

  getDataStateType() {
    return this.dataState;
  }
}
